import { DatePipe } from '@angular/common';
import { Injectable } from '@angular/core';
import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';
dayjs.extend(relativeTime);

@Injectable()
export class ColumnService {
    constructor(
        private datePipe: DatePipe
    ) { }

    formatType(type) {
        switch (type) {
            case 0:
                return '<span class="badge badge-primary"> Thing </span>';
            case 2:
                return '<span class="badge badge-primary"> Audit </span>';
            case 3:
                return '<span class="badge badge-primary"> Trigger </span>';
            case 4:
                return '<span class="badge badge-primary"> Campaign </span>';
            case 5:
                return '<span class="badge badge-primary"> License </span>';
            case 6:
                return '<span class="badge badge-primary"> CDP </span>';
            case 7:
                return '<span class="badge badge-primary"> Rate limit violation </span>';
            case 1:
            default:
                return '<span class="badge badge-primary"> System </span>';
        }
    }

    formatLevel(level) {
        switch (level) {
            case 0:
                return '<span class="badge badge-danger"> Error </span>';
            case 1:
                return '<span class="badge badge-warning"> Warning </span>';
            case 2:
            default:
                return '<span class="badge badge-info"> Information </span>';
        }
    }

    formatDate(date) {
        return this.datePipe.transform(date, 'yyyy-MM-dd hh:mm:ss Z');
    }

    formatAgoFormat(date, thing) {
        let str = 'Never';
        if (date === undefined) {
            return str;
        }
        if (thing !== undefined && thing.connected !== undefined && thing.connected) {
            str =
                '<span class="fa fa-link connected float-left"></span><span class="col-text-icon float-left">' +
                dayjs(date).fromNow() +
                '</span>';
        } else {
            str =
                '<span class="fa fa-link disconnected float-left"></span><span class="col-text-icon float-left">' +
                dayjs(date).fromNow() +
                '</span>';
        }
        return str;
    }

    formatColumn(name, col, thing) {
        let value = this.getValue(name, thing);
        if(!value) return '';

        switch (name) {
            case "status":
                return this.formatBadge({
                    type: this.statusToBadge(value),
                    value: value
                });
            case "dateAdded":
            case "dateActivated":
            case "dateModified":
            case "lastSync.session":
            case "lastSync.location":
            case "lastSync.dataUsage":
            case "lastSync.smsUsage":
            case "lastSync.voiceUsage":
                return this.formatDate(value);
            default:
                return value;
        }
    }

    getValue(name, thing){
        let prop = name.split('.');
        let result = thing;
        for (let p of prop){
            result = result ? result[p] : null;
        }
        return result;
    }

    formatBadge({value, type} : {value: string, type: string}){
        return `<span class="badge badge-${type}"> ${value} </span>`;
    }

    statusToBadge(val: string){
        switch(val){
            case "activated":
                return "success";
            case "deactivated":
                return "danger";
            default:
                return "secondary";
        }
    }
}
